

var _uiRouter = require('uiRouter');

var _squid = require('squid');

var _logger = require('xo-beaver/dist/logger');

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _index = require('xo-models/src/auth/index');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_angular2['default'].module().run(function () {
    var errorCount = 0;

    _angular.$rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
        var auth = _index.$AuthModel.instance();

        if (toState.auth !== false && !auth.logged_in) {
            errorCount += 1;
            if (errorCount === 10) {
                _logger.$logger.error('max_state_requires_auth');
            }
            if (errorCount >= 10) {
                return;
            }
            _logger.$logger.warn('state_requires_auth', {
                stateName: toState.name
            });
            event.preventDefault();
            throw new _squid.$Forbidden('state_transition_forbidden', { fromState: fromState, toState: toState });
        }
    });

    (0, _angular.$interval)(function () {
        var auth = _index.$AuthModel.instance();

        if (auth.logged_in) {
            // disallow_login_switch is used for Google Pay - acount linking to hide "not you" button (see xo-hercules/auth/outputMapper) and prevent user to be logged out
            // instead we should show error page
            if (auth.disallow_login_switch) {
                _uiRouter.$state.go('checkout.genericError', {
                    code: 'DEFAULT_TOKENIZED_WALLET_ERROR'
                });
                return;
            }

            auth.reload({ silent: true }).then(function () {
                if (_uiRouter.$state.current.auth !== false && !auth.logged_in) {
                    errorCount += 1;
                    if (errorCount === 10) {
                        _logger.$logger.error('max_state_requires_auth');
                    }
                    if (errorCount >= 10) {
                        return;
                    }
                    _logger.$logger.info('idle_timeout');
                    _logger.$logger.warn('state_requires_auth', {
                        stateName: _uiRouter.$state.current.name
                    });
                    errorCount += 1;
                    throw new _squid.$Forbidden();
                }
            });
        }
    }, 30 * 60 * 1000);

    _squid.$util.idleTimeout(10 * 60 * 60 * 1000);
});

_uiRouter.$state;

_squid.$Forbidden;

_squid.$util;

_logger.$logger;

_index.$AuthModel;


//////////////////
// WEBPACK FOOTER
// ./js/lib/security.js
// module id = ./js/lib/security.js
// module chunks = 0